import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridModel, GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { TravelDetailGridPostParams, TravelDetailListingModel } from 'common/models/page-models/travel-reimbursement/travel-detail-model';
import moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class TravelReimbursementDetailDataService extends GridDataService<TravelDetailListingModel, TravelReimbursementModel> {

  pageName = ''; // Store navPageType as pageName

  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.allAssignmentAndTravelReimbursementStudentList, http, ss);
  }

  createInstance(): TravelDetailListingModel {
    return new TravelDetailListingModel();
  }

  override getDeleteUrl(): string {
    return '';
  }

  override getGridParams(param: any): GridPostParams {
    const postParams = new TravelDetailGridPostParams();
    this.pageName = param.navPageType || ''; // Set pageName based on navPageType
    // console.log(this.pageName);
    console.log(param)
    postParams.id = param.id;
    console.log(param.navPageType, 'navpagetype')
    postParams.countFlag = param.navPageType === "Not Attended" ? 2: param.navPageType === 'Attended' ? 1 : parseInt(param.navPageType);
    // console.log(postParams, param, 'postParams');
    return postParams;
  }

  override getDataParam(): string {
    return 'assignmentStudentData';
  }

  override getExtraParam(): string {
    return 'details';
  }

  override transformDataModel(apiRes: any, param: string) {
    super.transformDataModel(apiRes, param);
  
    if (this.pageName === "0") {
      // console.log('All data displayed as navPageType is 0');
      apiRes.details[param] = apiRes.details[param]; // No filtering for "0"
    } else if (this.pageName === 'Not Attended') {
      apiRes.details[param] = apiRes.details[param].filter((data) => data.attended_flag === 0);
    } else if (this.pageName === 'Attended') {
      apiRes.details[param] = apiRes.details[param].filter((data) => data.attended_flag === 1);
    } else if (this.pageName === "3") {
      apiRes.details[param] = apiRes.details[param].filter((data) => data.travelDoc !== "");
    }
  
    // Always assign transformed data back to apiRes[param]
    apiRes[param] = apiRes.details[param];
  
    // Apply data transformations
    apiRes.details[param].forEach((data) => {
      data.travelDocument =  data.travelDoc !== null ? data.travelDoc : '-';
      data.attended = data.attended_flag === 1 ? 'Yes' : 'No';
      data.travelDocUploadedDate = data.travelDocUploadedDate
        ? moment(data.travelDocUploadedDate).format('YYYY-MM-DD HH:mm:ss')
        : '';
      data.travelStartDate = data.travelStartDate
        ? moment(data.travelStartDate).format('YYYY-MM-DD HH:mm:ss')
        : '';
      data.travelEndDate = data.travelEndDate
        ? moment(data.travelEndDate).format('YYYY-MM-DD HH:mm:ss')
        : '';
    });
  
    return apiRes;
  }
  
}